import { IModel, Model } from "@common/models/Model";

export interface IPetCustomReminderModel extends IModel {
  petId: number;
  salesItemName: string;
  reminded: boolean;
  dueDate: string;
  dateGiven: string;
  salesItemOptionId: number;
  reminderSourceId: number;
  reminderDays: number;
  //UI Prop
  reminderSourceName: string;
  attachmentStorageContent: FileList;
  notes: string;
}

export class PetCustomReminderModel extends Model implements IPetCustomReminderModel {
  petId: number;
  salesItemName: string;
  reminded: boolean;
  dueDate: string;
  dateGiven: string;
  salesItemOptionId: number;
  reminderSourceId: number;
  reminderDays: number;
  reminderSourceName: string;
  attachmentStorageContent: FileList;
  notes: string;

  constructor(params: IPetCustomReminderModel) {
    super(params);

    this.petId = _.defaultTo(params.petId, 0);
    this.salesItemName = _.defaultTo(params.salesItemName, "");
    this.reminded = _.defaultTo(params.reminded, false);
    this.dueDate = _.defaultTo(params.dueDate, "");
    this.dateGiven = _.defaultTo(params.dateGiven, "");
    this.salesItemOptionId = _.defaultTo(params.salesItemOptionId, 0);
    this.reminderSourceId = _.defaultTo(params.reminderSourceId, 0);
    this.reminderDays = _.defaultTo(params.reminderDays, 0);
    this.reminderSourceName = _.defaultTo(params.reminderSourceName, '');
    this.attachmentStorageContent = _.defaultTo(params.attachmentStorageContent,  [] as unknown as FileList);
    this.notes = _.defaultTo(params.notes, "");
  }
}
